<script setup lang="ts">
useHead({
  title: "Zenapptic AI - Virtual Production",
});
</script>

<template>
  <SolutionsLayout>
    <SolutionsDetailsTitle
      :background-url="`${useCdnUrl()}/assets/solutions/virtual-production/virtual-production
			-placeholder.webp`"
    >
      <template #videos>
        <source
          :src="`${useCdnUrl()}/assets/solutions/virtual-production/virtual-production.webm`"
          type="video/webm"
        />
      </template>

      <template #title><b>ENHANCED</b><br />VIRTUAL PRODUCTION</template>

      <template #description>
        Add new dimensions of engagement with <b>ZEN3</b>. <br />
        Augment any type of Virtual Production, from entertainment to enterprise productions, with
        interactive features.
      </template>
    </SolutionsDetailsTitle>

    <div class="feature-content">
      <SolutionsDetailsBlock>
        <template #image>
          <img
            :src="`${useCdnUrl()}/assets/solutions/virtual-production/xr-production.webp`"
            alt="XR Production"
          />
        </template>

        <template #title>ZENAPPTIC FOR<br />XR PRODUCTION</template>
        <template #description
          ><p>
            Deliver high-end virtual productions that are
            <b>easier to customize</b>, while <b>delivering immersive features</b> that bring
            customer events to the next level
          </p>
        </template>

        <template #items>
          <ul>
            <li>
              <b>Library of Templates:</b> Ready-to-use high-end 3D environments built for Unreal
              Engine or Unity that can be deployed as-is or fully customized for specific customer
              requirements
            </li>
            <li>
              <b>Audience Engagement:</b> Allows on-site and remote audiences to interact directly
              with a live event using smartphones, motion sensors, and more
            </li>
            <li>
              <b>ZEN3 Renderer:</b> Broadcast-quality render engine integrated with existing XR
              stages capable of adding real-time AR content
            </li>
            <li>
              <b>Custom Content:</b> Zenapptic’s Creative Services Team provides fully customized
              experiences including custom 3D environments tailored to your brand experience
            </li>
          </ul>
        </template>
      </SolutionsDetailsBlock>

      <ContentBlockSpacer />

      <SolutionsCalloutBlock
        :background-url="`${useCdnUrl()}/assets/solutions/virtual-production/diversified-background.webp`"
      >
        <template #details-left>
          <h2>
            When Diversified wanted to<br />create an XR Showcase for their<br />Global Summit, they
            turned to<br /><b>Zenapptic<span style="color: #aaa">.AI</span></b>
          </h2>
        </template>

        <template #details-right>
          <VideoPlayer
            :video-url="`${useCdnUrl()}/assets/solutions/virtual-production/diversified-video.webm`"
            ><img
              :src="`${useCdnUrl()}/assets/solutions/virtual-production/diversified-video-placeholder.webp`"
              alt="Command Center Demo"
          /></VideoPlayer>
        </template>
      </SolutionsCalloutBlock>
      <ContentBlockSpacer />
      <SolutionsSectionImmersiveFeatures />
      <ContentBlockSpacer />
      <SolutionsCalloutBlock
        :background-url="`${useCdnUrl()}/assets/solutions/virtual-production/zero-density-background.webp`"
      >
        <template #logo>
          <img
            :src="`${useCdnUrl()}/assets/solutions/virtual-production/zero-density-logo.png`"
            alt="Zero Density Logo"
            style="padding-bottom: 2rem; width: 35%"
          />
        </template>
        <template #details-left>
          <h2>
            Highlights from our<br />Virtual Production work<br />with <b>Zero Density</b><br />
            at <b>NAB 2024</b>
          </h2>
        </template>

        <template #details-right>
          <VideoPlayer
            :video-url="`${useCdnUrl()}/assets/solutions/virtual-production/david-presentation-nab-2024.webm`"
            ><img
              :src="`${useCdnUrl()}/assets/solutions/virtual-production/david-presentation-nab-2024-placeholder.webp`"
              alt="Command Center Demo"
          /></VideoPlayer>

          <VideoPlayer
            :video-url="`${useCdnUrl()}/assets/solutions/virtual-production/anton-interview-nab-2024.webm`"
            ><img
              :src="`${useCdnUrl()}/assets/solutions/virtual-production/anton-interview-nab-2024-placeholder.webp`"
              alt="Command Center Demo"
          /></VideoPlayer>
        </template>
      </SolutionsCalloutBlock>
    </div>

    <ContactBlock>
      <template #title>Want to know more?</template>
    </ContactBlock>
  </SolutionsLayout>
</template>
